import React from 'react';
import clsx from 'clsx';
import { Card } from '@common/components/card';

type Props = {
  open: boolean;
  label: React.ReactNode;
  className?: string;
};

export const CardCollapse = ({
  className,
  open,
  label,
  children,
}: React.PropsWithChildren<Props>) => (
  <>
    <Card
      className={clsx('wk-card-collapse', className, {
        'wk-card-collapse--open': open,
      })}
    >
      <div className="wk-card-collapse__container">
        {label}
        <span
          className={clsx(
            'wk-card-collapse__collapse',
            children && open && 'wk-card-collapse__collapse--open'
          )}
        >
          <span className="wk-card-collapse__content">{children}</span>
        </span>
      </div>
    </Card>
    <style jsx>{`
      .wk-card-collapse__container {
        display: flex;
        flex-direction: column;
      }
      .wk-card-collapse__collapse {
        width: 100%;
        display: grid;
        grid-template-rows: 0fr;
        opacity: 0;
        transition:
          grid-template-rows 0.25s ease-in-out,
          margin-top 0.25s ease-in-out,
          opacity 0.25s ease-in-out;
      }
      .wk-card-collapse__collapse--open {
        grid-template-rows: 1fr;
        opacity: 1;
        margin-top: 16px;
      }
      .wk-card-collapse__content {
        overflow: hidden;
      }
    `}</style>
  </>
);
